import React, { useEffect } from 'react';
import AppFooter from '../AppFooter';
import ReactGA from 'react-ga';
import Spinner from '../Spinner';
import { useState } from 'react';

const TRACKING_ID = "G-4TBWSBQEZS"; // OUR_TRACKING_ID


ReactGA.initialize(TRACKING_ID);



export default function AppDetails(props) {
  const [showSpinner, setShowSpinner] = useState(true);

  function handleIfrmeLoad() {
    console.log("iframe loaded");
  
    setShowSpinner(false);
  }

    useEffect(() => {
        document.title = props.name;
        document.body.style.backgroundColor= '#ddd6f3'
        ReactGA.pageview(window.location.pathname + window.location.search);
      }, []);


    return (
      <div id="facebook" className="app-container">
         <div class="app-title">
         <h1>{props.name}</h1>
         </div>
        
        <div class="google-data-studio">

        <iframe className="data-studio" src={`${props.dashboardLink}`} frameborder="0" style={{border:0}} onLoad={handleIfrmeLoad} ></iframe>
        </div>
        {showSpinner && <Spinner/>}

        <AppFooter
        shareText={`Checkout how ${props.name} releases their app on the Google Play` }
        />
           </div>
    );
}
  

